import Chart from "chart.js";

export default function(areaId,logicalList , knowledgeList, takeDateList) {
	var ctx = document.getElementById(areaId).getContext('2d');
	var logicalBorderColor = 'rgba(24,240,99)';

	var logicalBackgroundColor = 'rgba(24,240,99,0.8)';

	var knowledgeBorderColor = 'rgba(255,137,0)';

	var knowledgeBackGroundColor = 'rgba(255,137,0,0.8)';

	var knowledge = knowledgeList;
	//知識データ
	var logical = logicalList;
	//論理データ
	var date = takeDateList;

	//ラベルの色
	Chart.defaults.global.defaultFontColor = '#fff';

	//日時のデータ（X軸）
	var myAreaChart = new Chart(ctx, {
		type: 'line',
		data: {
			labels: date
			, datasets: [
				{
					label: '論理'
					, data: logical
					, borderColor: logicalBorderColor
					, backgroundColor: logicalBackgroundColor
					, lineTension: 0
				}
				,
				{
					label: '知識'
					, data: knowledge
					, borderColor: knowledgeBorderColor
					, backgroundColor: knowledgeBackGroundColor
					, lineTension: 0
				}]
		}, 
		plugins: [{
			afterDatasetsDraw: function(chart, ease) {
				for (var i = 1; i < date.length - 1; i++) {
					if (date[i] != '') {
						// カスタム描画を追加でおこなうため、データセットのメタデータを取得
						var meta = chart.getDatasetMeta(0);
						var data = meta.data;
						// X座標
						var x = data[i]._model.x;
						// Y座標
						var y_top = data[i]._yScale.top;
						var y_bottom = data[i]._yScale.bottom;


						// 垂直線の描画
						var context = chart.chart.ctx;
						context.beginPath();
//						context.lineWidth = 0.1;
						context.borderWidth = 2;
						context.strokeStyle = '#FFF';
						context.moveTo(x, y_top);
						context.lineTo(x, y_bottom);
						context.stroke();
					}
				}
			}
		}
		],
		options:
		{
			title: {
				display: true
				, text: '経験値量'
				, fontColor: 'white'
				, legend: {
					display: true
				}
			},
			scales:
			{
				xAxes: [                           // Ｘ軸設定
					{
						scaleLabel: {                 // 軸ラベル
							display: true,                // 表示設定
							fontColor: "#fff"            // 文字の色
						},
						gridLines: {                   // 補助線
							color: "rgba(255,255,255,0.2)", // 補助線の色
						},
						ticks: {                      // 目盛り
							fontColor: "white",             // 目盛りの色
						}
					}
				],
				yAxes: [                           // Ｙ軸設定
					{
						stacked: true//積み上げにする
						, ticks:
						{
							suggestedMin: 0
							, fontColor: "white"             // 目盛りの色
						}
						,
						gridLines: {                   // 補助線
							color: "white", // 補助線の色
							zeroLineColor: "white"         // y=0（Ｘ軸の色）
						}
					}
				]

			}
		}
	});
}